import { IState } from "../..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../../app/store";
import { UpdateOriginalCountsState } from "./OriginalCountsState";
import TerminalSummaryService from "app/data/terminal-summary/terminalsummaryService";

const initialState: UpdateOriginalCountsState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  errorMessage: null,
  data: {
    originalXgsCount: 0,
    originalRlmCount: 0,
    originalAgentCount: 0
  },
};

export const originalCountsSlice = createSlice({
  name: "originalCounts",
  initialState,
  reducers: {
    resetState: (state) => initialState,
    loading: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isError = false;
      state.errorMessage = null;
    },
    setOriginalCounts: (state, { payload }) => {
      state.data = payload;
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
      state.errorMessage = null;
    },
    error: (state) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.errorMessage = null;
    }
  }
});

const terminalSummaryService = TerminalSummaryService.getInstance();

export const {
  resetState,
  loading,
  setOriginalCounts,
  error,
} = originalCountsSlice.actions;

export const originalCountsSelector = (state: IState) => state.originalCounts;

export const getOriginalCounts = (
  status?: string | ""
): AppThunk => async (dispatch) => {
  dispatch(loading());
  const response = await terminalSummaryService.getOriginalCounts(status);

  if (response.ok() && response.data) {
    dispatch(setOriginalCounts(response.data));
  } else {
    dispatch(error());
  }
};

const originalCountsReducer = originalCountsSlice.reducer;
export default originalCountsReducer;